export default __webpack_public_path__ + "6736623a78ecdbc9203d678af23df971.svg";